import React from 'react';
import axios from 'axios';
import {
  Segment,
  Button,
  Table,
  Dimmer,
  Loader,
  Input,
  Radio,
  Search,
} from 'semantic-ui-react';
import { REGULAR_PATH } from '../../env';
import { alertMessage } from '../helper/alert-message';

class TemperatureSettings extends React.Component {
  state = {
    data: [],
    originalData: [],
    filteredData: [],
    loading: false,
    saving: false,
    searchQuery: '',
  };

  getAssets = () => {
    this.setState({ loading: true });
    axios
      .get(
        `${REGULAR_PATH}/temp_alert?access_token=${window.localStorage.getItem(
          'user',
        )}`,
      )
      .then(({ data }) => {
        this.setState({
          data,
          originalData: JSON.parse(JSON.stringify(data)), // Deep copy
          filteredData: data,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    this.getAssets();
  }

  handleSearchChange = (e, { value }) => {
    const { data } = this.state;
    const searchQuery = value.toLowerCase().trim();

    if (searchQuery === '') {
      this.setState({
        filteredData: data,
        searchQuery: value,
      });
    } else {
      const filteredData = data.filter((item) =>
        item.asset_name.toLowerCase().includes(searchQuery),
      );
      this.setState({
        filteredData,
        searchQuery: value,
      });
    }
  };

  handleInputChange = (assetIndex, alertIndex, field, value) => {
    const { data } = this.state;
    const updatedData = [...data];

    // Update the specific field in the nested structure
    updatedData[assetIndex].alert_list[alertIndex][field] = value;

    this.setState({ data: updatedData });

    // Also update filtered data to maintain search results
    this.updateFilteredData(updatedData);
  };

  updateFilteredData = (updatedData) => {
    const { searchQuery } = this.state;
    if (searchQuery === '') {
      this.setState({ filteredData: updatedData });
    } else {
      const filteredData = updatedData.filter((item) =>
        item.asset_name
          .toLowerCase()
          .includes(searchQuery.trim().toLowerCase()),
      );
      this.setState({ filteredData });
    }
  };

  handleStatusToggle = (assetIndex, alertIndex, alertItem, assetId) => {
    const { data } = this.state;
    const updatedData = [...data];

    updatedData[assetIndex].alert_list[alertIndex].alert_status =
      !updatedData[assetIndex].alert_list[alertIndex].alert_status;

    this.setState({ data: updatedData });

    this.updateFilteredData(updatedData);
  };

  handleSave = () => {
    const { data, originalData } = this.state;

    const changedData = [];

    data.forEach((asset, assetIndex) => {
      asset.alert_list.forEach((alert, alertIndex) => {
        const originalAlert = originalData[assetIndex].alert_list[alertIndex];

        // Check if any field has changed
        if (originalAlert) {
          const hasChanged =
            alert.alert_status !== originalAlert.alert_status ||
            parseInt(alert.alert_min) !== parseInt(originalAlert.alert_min) ||
            parseInt(alert.alert_max) !== parseInt(originalAlert.alert_max);

          if (hasChanged) {
            changedData.push({
              asset_id: asset.asset_id,
              sensor_number: alert.sensor_number,
              alert_status: alert.alert_status,
              alert_min: parseInt(alert.alert_min) || 0,
              alert_max: parseInt(alert.alert_max) || 0,
            });
          }
        }
      });
    });

    if (changedData.length === 0) {
      return;
    }

    const payload = { data: changedData };

    this.setState({ saving: true });

    axios
      .put(
        `${REGULAR_PATH}/temp_alert?access_token=${window.localStorage.getItem(
          'user',
        )}`,
        payload,
      )
      .then((response) => {
        this.setState({ saving: false });
        // Update originalData to reflect the new saved state
        this.setState({ originalData: JSON.parse(JSON.stringify(data)) });

        alertMessage(response.data.status);
      })
      .catch((error) => {
        console.error('Save failed:', error);
        this.setState({ saving: false });
      });
  };

  render() {
    const { data, filteredData, loading, searchQuery } = this.state;

    if (loading) {
      return (
        <Dimmer active={true}>
          <Loader indeterminate size='big'>
            Loading...
          </Loader>
        </Dimmer>
      );
    }

    const isOrg = ['66e2a431faf103d2b7178958', '6a802809646454758012e38b', '6a2a51a16464544e9b309cf1', '6ac4a581646454a24c410798', '6995aa4a6464547f136eb0cf'].includes(
      window.localStorage.getItem('organization'),
    );
    const isAdmin = window.localStorage.getItem('org_admin') === 'true';

    if (!isOrg || !isAdmin) {
      return <h2>You are not authorized person.</h2>;
    }

    return (
      <Segment>
        <Segment>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <h3>Temperature Settings</h3>
            </div>
            <Button primary onClick={this.handleSave}>
              Save
            </Button>
          </div>
        </Segment>
        <Table called style={{ borderBottom: 'none' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>No</Table.HeaderCell>
              <Table.HeaderCell>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  Asset
                  <Search
                    placeholder='Search assets...'
                    value={searchQuery}
                    onSearchChange={this.handleSearchChange}
                    showNoResults={false}
                  />
                </div>
              </Table.HeaderCell>
              <Table.HeaderCell>Temperatures</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {filteredData.map((item, filteredIndex) => {
              // Find the original index in the full data array for proper state updates
              const originalIndex = data.findIndex(
                (dataItem) => dataItem.asset_id === item.asset_id,
              );

              return (
                <Table.Row key={item.asset_id} style={{ width: 300 }}>
                  <Table.Cell>{filteredIndex + 1}</Table.Cell>
                  <Table.Cell>{item.asset_name}</Table.Cell>
                  <Table.Cell style={{ padding: 0 }}>
                    <Table style={{ borderBottom: 'none' }}>
                      {filteredIndex === 0 ? (
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell style={{ width: 250 }}>
                              Name
                            </Table.HeaderCell>
                            <Table.HeaderCell>Normal Range</Table.HeaderCell>
                            <Table.HeaderCell>Alert</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                      ) : null}
                      <Table.Body style={{ borderColor: 'white' }}>
                        {item.alert_list.map((alertItem, alertIndex, arr) => {
                          return (
                            <Table.Row
                              key={`${alertIndex}-${alertItem.sensor_name}`}
                            >
                              <Table.Cell style={{ width: 300 }}>
                                {alertItem.sensor_name}
                              </Table.Cell>
                              <Table.Cell>
                                <div style={{ display: 'flex', gap: 20 }}>
                                  <Input
                                    label='Min'
                                    type='number'
                                    fluid
                                    style={{ width: 130 }}
                                    placeholder='Min Value'
                                    value={alertItem.alert_min}
                                    onChange={(e) =>
                                      this.handleInputChange(
                                        originalIndex,
                                        alertIndex,
                                        'alert_min',
                                        e.target.value,
                                      )
                                    }
                                  />
                                  <Input
                                    label='Max'
                                    type='number'
                                    fluid
                                    style={{ width: 130 }}
                                    placeholder='Max Value'
                                    value={alertItem.alert_max}
                                    onChange={(e) =>
                                      this.handleInputChange(
                                        originalIndex,
                                        alertIndex,
                                        'alert_max',
                                        e.target.value,
                                      )
                                    }
                                  />
                                </div>
                              </Table.Cell>
                              <Table.Cell>
                                <Radio
                                  toggle
                                  checked={alertItem.alert_status}
                                  onChange={() =>
                                    this.handleStatusToggle(
                                      originalIndex,
                                      alertIndex,
                                      alertItem,
                                      item.asset_id,
                                    )
                                  }
                                />
                              </Table.Cell>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                    </Table>
                  </Table.Cell>
                </Table.Row>
              );
            })}
            {filteredData.length === 0 && searchQuery && (
              <Table.Row>
                <Table.Cell colSpan='3' textAlign='center'>
                  No assets found matching "{searchQuery}"
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default TemperatureSettings;
